import Store from '@/store/index.js'
import Constant from '@/const'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 納期検索問い合わせメール
    sendTrialMail({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.MAIL_TRIAL}`,
        params: data,
        error: {
          message: '料金納期検索のお問い合わせメール送信に失敗しました。',
        },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // 試用納期検索問い合わせメール
    sendSimpleTrialMail({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.MAIL_SIMPLE_TRIAL}`,
        params: data,
        error: {
          message: '試用料金納期検索のお問い合わせメール送信に失敗しました。',
        },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/mail.js